import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

const MINUTES = [0, 15, 30, 45];
const HOURS = new Array(24 * 4).fill(0).map((_, i) => {
  const hour = Math.floor(i / 4)
    .toString()
    .padStart(2, '0');
  const minute = MINUTES[i % 4].toString().padStart(2, '0');
  return `${hour}:${minute}`;
});

/**
 * @typedef {Object} ChatStatsDataReducer
 * @property {Array<{name: string, value: string}>} channels
 * @property {number} nbCustomerMessages
 * @property {number} nbSentMessages
 * @property {number} nbInternalMessages
 * @property {number} averagePerIntervention
 * @property {number} averageTimeToAnswer
 * @property {Array<{name: string, sentIntervention: number, hasCustomerMessages: number, hasInternalMessages: number}>} messagesByIntervention
 * @property {Array<{name: string, value: number}>} messagesDistribution
 */

/** @type {ChatStatsDataReducer} */
const initialState = {
  channels: [],
  nbCustomerMessages: null,
  nbSentMessages: null,
  nbInternalMessages: null,
  averagePerIntervention: null,
  averageTimeToAnswer: null,
  messagesByIntervention: null,
  messagesDistribution: [],
  nbMediaFilesSharedWithCustomers: null,
  nbMediaFileSharedInternally: null,
  averageNbMediaFilesSharedInChatPerFile: null,
  nbMediaFilesSentToCustomers: [],
  nbMediaFilesReceivedToCustomers: [],
};

/**
 * @param {State} _
 * @param {import('modules/statistics/types').FetchChatStatisticsSuccessAction} action
 * @returns {State}
 */
const updateAllData = (_, { payload }) => ({
  ...payload,
  messagesDistribution: HOURS.map(name => ({
    name,
    value: payload.messagesDistribution?.find(item => item.time.indexOf(name) === 0)?.id ?? 0,
  })),
  nbCustomerMessages: payload.channels?.reduce((acc, { id }) => acc + (id ?? 0), 0) ?? 0,
  averagePerIntervention: (payload.averagePerIntervention || 0).toFixed(2),
  channels: payload.channels?.map(({ channel: name, id: value }) => ({ name, value })) ?? [],
  messagesByIntervention:
    payload.messagesByIntervention?.map(({ sentOn, ...item }) => ({
      ...item,
      sentIntervention: sentOn, // We rename it to handle the different color :|
    })) ?? [],
  averageNbMediaFilesSharedInChatPerFile: (payload.averageNbMediaFilesSharedInChatPerFile || 0).toFixed(2),
});

export default createReducer(initialState, {
  [types.FETCH_CHAT_STATISTICS_SUCCESS]: updateAllData,
});
